import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Form,
  Image,
  Input,
  Select,
  Button,
  Menu,
  Dropdown,
  message,
} from "antd";
import { Bar, Column, Pie } from "@ant-design/plots";
import { connect } from "react-redux";
import { actionGetUsersAll } from "../../store/actions/userAction";
import filter from "../../assets/img/icon/filter1.png";
import { actionSendNotification } from "../../store/actions/notificationAction";
import { actionGetDashboardData } from "../../store/actions/ticketAction";
import {
  CalendarOutlined,
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined,
  LinkOutlined,
} from "@ant-design/icons";

const Dashboard = (props) => {
  const {
    actionGetUsersAll,
    usersLoader,
    actionGetDashboardData,
    dashboardData,
    dashboardLoader,
    usersCount,
    notificationLoader,
    notificationData,
    usersData,
  } = props;

  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    actionGetDashboardData();
  }, []);

  const x = usersData
    .filter((user) => user.roles === "admin" || user.roles === "user")
    .map((user) => ({
      title: user.first_name + " " + user.last_name,
      value: user._id,
    }));
  console.log(!selectedValues || selectedValues.length === 0);

  // const onFinish = (values) => {
  //   if (
  //     selectedValues &&
  //     selectedValues.length === 0 &&
  //     !values.title &&
  //     !values.description
  //   ) {
  //     setValidationMessage("Please Select User and enter title and message");
  //   } else if (selectedValues && selectedValues.length === 0) {
  //     setValidationMessage("Please Select User");
  //   } else {
  //     setValidationMessage("");
  //     console.log("object");
  //     actionSendNotification({ ...values, users: selectedValues });
  //     form.resetFields();
  //     setSelectedValues([]);
  //   }
  // };

  const [form] = Form.useForm();

  const data = [];

  dashboardData.ticket_aging &&
    dashboardData.ticket_aging.length > 0 &&
    dashboardData.ticket_aging.map((d, i) => {
      data.push({
        name: d.name,
        value: d.value,
      });
    });

  const config = {
    data,
    xField: "name",
    yField: "value",
    color: "#265BA6",
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },

    minColumnWidth: 40,
    maxColumnWidth: 40,
  };

  // get Data Second Chart

  const dataPie = [];
  dashboardData.total_tickets &&
    dashboardData.total_tickets.length &&
    dashboardData.total_tickets.map((d, i) => {
      dataPie.push({
        key: i,
        name: d.name,
        value: d.value,
      });
    });

  const configPie = {
    appendPadding: 10,
    data: dataPie,
    color: ["#265BA6", "#E42126"],
    angleField: "value",
    colorField: "name",
    radius: 0.8,
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };

  // Get Third Data

  const hoursPieData = [
    {
      type: "Consumed Hours",
      value: 27,
    },
    {
      type: "Total Hours",
      value: 25,
    },
  ];

  // Get Data HoursPic
  // const hoursPieData = [];
  // dashboardData &&
  //   dashboardData.length > 0 &&
  //   dashboardData.map((d, i) => {
  //     hoursPieData.push({
  //       type: "Consumed Hours",
  //       value: 27,
  //     });
  //   });

  const hoursPie = {
    appendPadding: 10,
    data: hoursPieData,
    color: ["#265BA6", "#E42126"],
    angleField: "value",
    colorField: "type",
    radius: 0.8,
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: "center",
      },
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };

  const items = [
    {
      label: (
        <>
          <Button
            type="primary"
            className="flex items-center justify-center"
            icon={<Image src={filter} preview={false} alt="Filter" />}
            size={"large"}
          />
        </>
      ),
      key: "sub1",
      children: [
        {
          label: "Option 1",
          key: "1",
          icon: <MailOutlined />,
        },
        {
          label: "Option 2",
          key: "2",
          icon: <AppstoreOutlined />,
        },
      ],
    },
  ];
  const onSubMenuClick = ({ key }) => {
    const currentSelectedItems = selectedItems.includes(key)
      ? selectedItems.filter((item) => item !== key)
      : [...selectedItems, key];

    setSelectedItems(currentSelectedItems);
  };

  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
  };

  return (
    <Fragment>
      <Row gutter={[16, 16]} className="top-card">
        <Col span={24}>
          <Row gutter={[16, 16]} className="center-card">
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
            dashboardData.dashboard_count &&
            dashboardData.dashboard_count.total_draws
              ? dashboardData.dashboard_count.total_draws
              : ""} */}
                <Typography.Text>Unresolved</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
                dashboardData.dashboard_count &&
                dashboardData.dashboard_count.today_sold_tickets
                  ? dashboardData.dashboard_count.today_sold_tickets
                  : ""} */}
                <Typography.Text>Overdue</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
                dashboardData.dashboard_count &&
                dashboardData.dashboard_count.total_orders
                  ? dashboardData.dashboard_count.total_orders
                  : ""} */}
                <Typography.Text>Due Today</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
                dashboardData.dashboard_count &&
                dashboardData.dashboard_count.active_users
                  ? dashboardData.dashboard_count.active_users
                  : ""} */}
                <Typography.Text>Open</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
                dashboardData.dashboard_count &&
                dashboardData.dashboard_count.active_users
                  ? dashboardData.dashboard_count.active_users
                  : ""} */}
                <Typography.Text>In Process</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={4}>
              <Card align="left" bordered={false}>
                {/* {dashboardData &&
                dashboardData.dashboard_count &&
                dashboardData.dashboard_count.active_users
                  ? dashboardData.dashboard_count.active_users
                  : ""} */}
                <Typography.Text>Closed</Typography.Text>
                <br />
                <Typography.Text>1</Typography.Text>
              </Card>
            </Col>
            <Col span={24} />
            {/* <Col
              span={24}
              align="right"
              className="custom-dropdown text-right flex justify-end py-4"
            >
              <Menu
                selectable
                onOpenChange={onSubMenuClick}
                selectedKeys={selectedItems}
                mode="horizontal"
                triggerSubMenuAction="click"
                style={{
                  // width: 200,
                  background: "none", // Hide the default background color
                  border: "none",
                  marginLeft: "auto", // Hide the default border
                }}
                onClick={onClick}
                items={items}
              /> */}
            {/* <Dropdown className=""
                menu={{
                  onClick,
                  items,
                }}
                trigger={["click"]}
              >
                <Button
                  type="primary"
                  className="flex items-center justify-center"
                  icon={<Image src={filter} preview={false} alt="Filter" />}
                  size={"large"}
                />
              </Dropdown> */}
            {/* </Col> */}

            <Col span={8}>
              <Card
                title="Tickets Ageing"
                bordered={false}
                style={{ height: 500 }}
              >
                <Column {...config} />
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Total Tickets V/S Resolved Tickets" bordered={false}>
                <Pie {...configPie} />
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Total Hours V/S Consumed Hours" bordered={false}>
                <Pie {...hoursPie} />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    usersLoader: state.users.usersLoader,
    usersCount: state.users.usersCount,
    usersData: state.users.usersData,
    notificationLoader: state.notification.notificationLoader,
    notificationData: state.notification.notificationData,
    dashboardLoader: state.orders.dashboardLoader,
    dashboardData: state.orders.dashboardData,
  };
};
export default connect(mapStateToProps, {
  actionGetUsersAll,
  actionGetDashboardData,
  actionSendNotification,
})(Dashboard);
